import { Component, OnInit } from '@angular/core';
import {MenuItem} from 'primeng/api';


@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.css']
})
export class MainPageComponent implements OnInit {

  weekdays: string[] = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes'];

  constructor() { }

  ngOnInit(): void {

  }

}
